import { UpsertIncome } from '../../../member-profile/components/UpsertIncome';

const AddIncomePage = () => {
    return <UpsertIncome />;
};

export default AddIncomePage;
